
export enum BookingDuration {
    SHORT = 'short',
    WEEK = 'week',
    MONTH = 'month',
    CUSTOM = 'custom',
}

export class BookingDurationHelper {

    /**
     * Get options
     */
    static getOptions(): BookingDuration[] {
        return [
            BookingDuration.SHORT,
            BookingDuration.WEEK,
            BookingDuration.MONTH,
            BookingDuration.CUSTOM,
        ];
    }

    /**
     * Get booking duration
     * @param bookingDuration
     */
    static getBookingDuration(bookingDuration: string): BookingDuration {
        switch (bookingDuration) {
            case 'short':
                return BookingDuration.SHORT;
            case 'week':
                return BookingDuration.WEEK;
            case 'month':
                return BookingDuration.MONTH;
            case 'custom':
                return BookingDuration.CUSTOM;
        }

        return BookingDuration.CUSTOM;
    }

    /**
     * Get booking duration label
     * @param bookingDuration duration
     * @param brand brand
     */
    static getBookingDurationLabel(bookingDuration: BookingDuration, brand: string|null): string {
        switch (bookingDuration) {
            case BookingDuration.SHORT:
                if (brand === 'act_skip_hire') {
                    return 'Short (3 Days)';
                }
                return 'Short (3 Days)';
            case BookingDuration.WEEK:
                if (brand === 'act_skip_hire') {
                    return 'Week (7 Days)';
                }
                return 'Week (7 Days)';
            case BookingDuration.CUSTOM:
                return 'Custom';
            case BookingDuration.MONTH:
                return 'Month (27 Days)';
        }
    }

    /**
     * Get billing days
     * @param bookingDuration
     */
    static getTotalDays(bookingDuration: BookingDuration): number|null {
        switch (bookingDuration) {
            case BookingDuration.SHORT:
                return 4;
            case BookingDuration.WEEK:
                return 8;
            case BookingDuration.MONTH:
                return 28;
            case BookingDuration.CUSTOM:
                return null;
        }
    }

    /**
     * Get additional calendar days
     * @param bookingDuration
     */
    static getBillableDays(bookingDuration: BookingDuration): number {
        switch (bookingDuration) {
            case BookingDuration.SHORT:
                return 3;
            case BookingDuration.WEEK:
                return 7;
            case BookingDuration.MONTH:
                return 27;
            case BookingDuration.CUSTOM:
                return 0;
        }
    }
}
